import React from "react";
import { motion } from "framer-motion";
import "../styles/Contact.css";
import jmLogo from "../assets/misc/jm.png";

const Contact = () => {
  const email = "jhnmndz255@gmail.com";

  // Parent/stagger controller
  const container = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.12,
      },
    },
  };

  // Shared fade-up animation for all text/icons
  const fadeUp = {
    hidden: { opacity: 0, y: 24 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };

  return (
    <section id="contact" className="contact-section">
      <motion.div
        className="contact-inner"
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.4 }}
      >
        {/* Logo */}
        <motion.img
          variants={fadeUp}
          src={jmLogo}
          alt="John Mendez logo"
          className="contact-logo"
        />

        {/* Heading */}
        <motion.h2 variants={fadeUp} className="contact-heading">
          Seen enough? Let's connect
        </motion.h2>

        {/* Email + Icons */}
        <motion.div variants={fadeUp} className="contact-row">
          <motion.div
            variants={fadeUp}
            className="contact-icons"
          >
            {/* Email icon */}
            <motion.a
              variants={fadeUp}
              href={`mailto:${email}`}
              className="contact-icon"
              aria-label="Email John"
            >
              <svg
                viewBox="0 0 24 24"
                className="contact-icon-svg"
                aria-hidden="true"
              >
                <rect
                  x="3"
                  y="5"
                  width="18"
                  height="14"
                  rx="2"
                  ry="2"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.6"
                />
                <polyline
                  points="4 6.5 12 12 20 6.5"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </motion.a>

            {/* LinkedIn icon */}
            <motion.a
              variants={fadeUp}
              href="https://www.linkedin.com/in/john-mendez-b1a79820a/"
              target="_blank"
              rel="noreferrer"
              className="contact-icon"
              aria-label="John on LinkedIn"
            >
              <svg
                viewBox="0 0 24 24"
                className="contact-icon-svg"
                aria-hidden="true"
              >
                <rect
                  x="3"
                  y="3"
                  width="18"
                  height="18"
                  rx="3"
                  ry="3"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.6"
                />
                <rect x="7" y="10" width="2" height="7" rx="1" />
                <circle cx="8" cy="7" r="1.2" />
                <path d="M13 17v-4.1c0-1.1.7-1.9 1.8-1.9 1 0 1.7.7 1.7 1.9V17" />
              </svg>
            </motion.a>
          </motion.div>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Contact;
